<template>
    <div>
        <div class="tags are-medium">
            <div class="tag" v-if="selectedCountries.length === 0">
                <span class="icon">
                    <i class="fas fa-globe"></i>
                </span>
                <span>{{ translate("notification_center.all_countries") }}</span>
            </div>
            <template v-else>
                <div v-for="selectedCountry in selectedCountries" class="tag" :key="selectedCountry">
                    <span class="icon">
                        <i :class="getIconClassForCountry(selectedCountry)" />
                    </span>
                    <span>
                        {{ translateCountryCode(selectedCountry) }}
                    </span>
                </div>
            </template>
        </div>
        <div class="tags are-medium">
            <PaymentStatusTag :payment-status="paymentStatus" />
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import translatorMixin from "../../Common/translatorMixin";
    import { COUNTRY_NOT_AVAILABLE } from "../../Common/consts";
    import PaymentStatusTag from "../Common/PaymentStatusTag.vue";

    export default {
        name: "selected-countries",
        components: { PaymentStatusTag },
        mixins: [translatorMixin],
        computed: {
            ...mapState("filteringReceivers", ["selectedCountries", "paymentStatus"]),
        },
        methods: {
            getIconClassForCountry(countryCode) {
                if (countryCode === COUNTRY_NOT_AVAILABLE) {
                    return "fas fa-question-circle";
                }

                return "flag-icon flag-icon-" + countryCode.toLowerCase();
            },
            getTagForPayment() {
                if (this.paymentStatus === 0) {
                    return "is-info";
                }
                if (this.paymentStatus === 1) {
                    return "is-success";
                }
                if (this.paymentStatus === 2) {
                    return "is-danger";
                }
            },
        },
    };
</script>

<style scoped></style>
